

import * as Configuration from '../../../app.constants.js';

export class BusinessHoursService {
  constructor($http, $q, $translate) {
    this.$http = $http;
    this.$q = $q;
    this.$translate = $translate;
  }

  _BusinessHoursURL(companyId) {
    return Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/business-hours-for-sites-and-routing-tags';
  }

  getBusinessHoursConfig(companyId) {
    return this.$http.get(this._BusinessHoursURL(companyId));
  }

  updateBusinessHours(companyId, config) {
    return this.$http.put(this._BusinessHoursURL(companyId), config);
  }

  daysOfWeek() {
    return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  }

  static BusinessHoursFactory($http, $q, $translate) {
    return new BusinessHoursService($http, $q, $translate);
  }
}

BusinessHoursService.BusinessHoursFactory.$inject = ['$http', '$q', '$translate'];
